/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';
import { Attachment, IAttachment } from '../../../app-data/models/Attachment';
import { ProjectFile } from '../../../app-data/models/ProjectFile';
import { IFancyIdJoin } from '../base/FancyIdJoin';
import { AngularLandConnection } from '../base/interfaces';
import { LocalAction } from '../base/LocalSnapshot';
import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { DefaultSplitDataRenderType } from '@touchplan/common';

export class AttachmentList
	extends FancyFirebaseSplitDataList<IAttachment, DefaultSplitDataRenderType, Attachment>
	implements IFancyIdJoin
{
	constructor(angularLand: AngularLandConnection, path: any, fancyJoins?: IFancyIdJoin) {
		super(angularLand, path, fancyJoins);
	}

	public $$added(action: LocalAction<DatabaseSnapshot<any>>) {
		const definition = new Attachment(action.payload.key);
		if (action.type === 'child_added') {
			// firebase
			definition.databaseUpdate(action.payload.val());
		} else if (action.type === 'add_item') {
			// local
			definition.localDatabaseUpdate(action.payload.val());
		}
		return definition;
	}

	public $$updated(child: Attachment, action: AngularFireAction<DatabaseSnapshot<any>>) {
		super.$$updated(child, action);
	}

	public applyJoinData(baseKey: string, child: Attachment, otherChild: ProjectFile) {
		switch (baseKey) {
			case 'thumbnailFileId':
				child.view.thumbnailFile = otherChild?.view;
				break;
			case 'previewFileId':
				child.view.previewFile = otherChild?.view;
				break;
			case 'fileId':
				child.view.file = otherChild?.view;
				break;
			default:
				break;
		}
	}

	public getDataForKey(baseKey: string, child: Attachment) {
		return child.view[baseKey];
	}
}
